import React from 'react';
import useCurrentOrg from '@/lib/hooks/swr/useCurrentOrg';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { Dialogs, useDialogManager } from '@/modules/Dialogs';
import BulkImportStatus from '../config/BulkImportStatus';
import useUpdateBulkImport from './useUpdateBulkImport';

const DataUploadsDialogMessage = (orgName: string) =>
  translate('DATA_UPLOADS_DESTROY_ALL_DATA_MESSAGE', {
    orgName,
    warn: (...text: string[]) => (
      <span className="text-error-main">{text}</span>
    ),
  });

const useDestroyAllDataDialog = () => {
  const { openDialog, closeDialog } = useDialogManager();
  const { data } = useCurrentOrg();
  const { orgName } = data ?? '';

  const updateBulkImport = useUpdateBulkImport();

  const showDestroyAllDataDialog = (bulkImportId: string) =>
    openDialog(Dialogs.CONFIRMATION, {
      children: DataUploadsDialogMessage(orgName),
      confirmLabel: (
        <span className="uppercase">
          {translate('DATA_UPLOADS_DESTROY_ALL_DATA')}
        </span>
      ),
      headerText: (
        <span className="uppercase">
          {translate('DATA_UPLOADS_DESTROY_ALL_DATA')}
        </span>
      ),
      onCancel: closeDialog,
      onClose: closeDialog,
      onConfirm: () => {
        updateBulkImport({
          bulkImportId,
          status: BulkImportStatus.REVERT,
        });
      },
    });

  return showDestroyAllDataDialog;
};

export default useDestroyAllDataDialog;
